import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";

export default function SiteLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}